import styled from 'styled-components';

import {
  Radio as SemanticRadio,
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';
import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div``;

const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Name = styled(TextLayoutComponent.Title)``;

const ContainerName = styled.div`
  width: 60%;
`;

const ButtonDeleteUser = styled(ButtonLayoutComponent.Danger)``;

const ContainerButtonTab = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 10px;
`;

const ButtonTab = styled.button`
  border: none;
  height: 50px;
  padding: 7px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 400;
`;

const TextTesterStatus = styled(TextLayoutComponent)``;

const TextProfileEditing = styled(TextLayoutComponent)`
  line-height: 0;
`;

const ContainerTesterStatus = styled.div`
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 73px;
`;

const ProfileEditionContainer = styled.div`
  display: flex;
  gap: 0.6rem;
  align-items: center;
`;

const Radio = styled(SemanticRadio)``;

const LinkChangeTesterStatus = styled.a`
  margin-left: 5px;
`;

const ButtonAddPayment = styled(ButtonLayoutComponent)`
    &.ui.button {
      margin: 20px 0;
  }
`;

const ButtonBack = styled(TextLayoutComponent)`
  cursor: pointer;
  color: ${(props) => props.theme.color.primary};
  font-size: 18px;
  width: 190px;
`;

const ContainerTable = styled.div`
  margin-top: 20px;
  padding: 40px;
`;

const Dropdown = styled(SemanticDropdown)`
  padding: 0 3px;
`;

const AdditionalInformation = styled.div`
  margin: 10px 0 10px 0;
`;

const Text = styled(TextLayoutComponent)`
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => props.theme.color.secondary};
`;

export {
  Container,
  TopContainer,
  Name,
  ContainerName,
  ButtonDeleteUser,
  TextTesterStatus,
  ContainerTesterStatus,
  LinkChangeTesterStatus,
  ButtonAddPayment,
  ButtonBack,
  ContainerTable,
  Radio,
  ProfileEditionContainer,
  TextProfileEditing,
  Dropdown,
  ButtonTab,
  ContainerButtonTab,
  AdditionalInformation,
  Text,
};
